module.exports = __webpack_public_path__ + "img/api-bian.c3110d17.png";